import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmapItemWithCustomProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { EXTRA_LARGE, LARGE, MEDIUM } from 'components/Dashboards/Reporting/reportingConfig';
import { IGanttChartProps } from 'components/widgets/Gantt/GanttChart';

export const ganttChart: IHashmapItemWithCustomProps<IGanttChartProps> = {
    NoPermissionMessage,
    reportStyle: {
        widgetSizesAvailable: { medium: MEDIUM, large: LARGE, extraLarge: EXTRA_LARGE },
        widgetInitialSize: LARGE,
    },
};
